// @mui material components
import { CircularProgress, Backdrop, Snackbar, Alert, Card, Grid, Icon } from "@mui/material";

import { useState } from "react";
// import axios from "axios.js";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
// import MDInput from "theme/components/MDInput";
import MDTypography from "theme/components/MDTypography";
// import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
import { useAuthUser } from "react-auth-kit";

import { useNavigate } from "react-router-dom";
import MDButton from "components/MDButton";

function HomeDashboard() {
  const pageTitle = "Laddar Portal - Home";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const auth = useAuthUser();
  const user = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
    setSeverity("error");
    setShowLoading(false);
  };

  function greet() {
    const myDate = new Date();
    const hours = myDate.getHours();
    let greetingMsg;

    if (hours < 12) greetingMsg = "morning";
    else if (hours >= 12 && hours <= 15) greetingMsg = "afternoon";
    else if (hours >= 16 && hours <= 24) greetingMsg = "evening";

    return `Good ${greetingMsg}`;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mb={5}>
        <MDBox mt={1}>
          <MDBox mb={3}>
            <Card>
              <MDBox p={2}>
                <MDBox align="right">
                  <MDTypography variant="h6" fontWeight="light" alignText="right">
                    {greet()} <b>{user.user.first_name}</b>,
                  </MDTypography>
                </MDBox>
                <MDBox
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "15vh",
                  }}
                >
                  <MDBox align="center">
                    <MDBox>
                      <MDTypography variant="h2">Laddar Portal</MDTypography>
                    </MDBox>
                    <MDBox m={1}>
                      <MDTypography variant="h6" fontWeight="light">
                        {user.account.title}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
          <MDBox mt={5}>
            <Grid container spacing={{ xs: 2, md: 3, lg: 3 }}>
              <Grid item xs={6} md={6} lg={6}>
                <Card sx={{ height: "100%" }}>
                  <MDBox
                    p={2}
                    sx={{ height: "25vh" }}
                    display="flex"
                    justifyContent="space-between"
                    flexDirection="column"
                  >
                    <MDBox>
                      <MDTypography variant="h6" fontSize={18}>
                        <Icon color="dark">list</Icon> &nbsp; Campaigns
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontSize={14} fontWeight="light">
                        Start your journey with campaigns. Setup sales or data capture campaigns,
                        manage targets, commissions and more.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDButton
                        variant="outlined"
                        color="info"
                        startIcon={<Icon>list</Icon>}
                        onClick={() => {
                          navigate("/campaigns");
                        }}
                      >
                        Campaigns
                      </MDButton>
                      &nbsp;&nbsp;
                      <MDButton
                        variant="outlined"
                        color="warning"
                        startIcon={<Icon>insights</Icon>}
                        onClick={() => {
                          navigate("/dashboard");
                        }}
                      >
                        Overview
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={6} md={6} lg={6}>
                <Card sx={{ height: "100%" }}>
                  <MDBox
                    p={2}
                    sx={{ height: "100%" }}
                    display="flex"
                    justifyContent="space-between"
                    flexDirection="column"
                  >
                    <MDBox>
                      <MDTypography variant="h6" fontSize={18}>
                        <Icon color="dark">support_agent</Icon> &nbsp; Team
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontSize={14} fontWeight="light">
                        Team management made easy. Manage your agents effectively. Monitor
                        performance, track field activities and reward seamlessly.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDButton
                        variant="outlined"
                        color="info"
                        startIcon={<Icon>list</Icon>}
                        onClick={() => {
                          navigate("/agents");
                        }}
                      >
                        Agents
                      </MDButton>
                      &nbsp;&nbsp;
                      <MDButton
                        variant="outlined"
                        color="dark"
                        startIcon={<Icon>groups</Icon>}
                        onClick={() => {
                          navigate("/agent-groups");
                        }}
                      >
                        Groups
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default HomeDashboard;
